<template>
  <div class="addLink">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      size="small"
    >
      <el-form-item label="资源分类" prop="categoryId">
        <el-select v-model="ruleForm.categoryId" placeholder="请选择资源分类">
          <el-option
            v-for="item in resourceDatas"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="链接名称" prop="linkName">
        <el-input
          v-model="ruleForm.linkName"
          maxlength="20"
          placeholder="请输入链接名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="链接地址" prop="linkUrl">
        <el-input
          type="textarea"
          v-model="ruleForm.linkUrl"
          placeholder="请输入链接地址"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import * as api from "@/api/newCourseApi.js";
export default {
  name: "addLink",
  components: {},
  props: {
    courseId: {
      type: [Number, String],
      default: "",
    },
    tableRowData: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    const reg = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;

    let checkUrl = (rule, value, callback) => {
　　　　value ? reg.test(value) ? callback() :
　　　　callback(new Error('请输入正确的链接地址')) :
　　　　callback(new Error('请输入链接地址'));
　　};
    return {
      resourceDatas: [],
      ruleForm: {
        categoryId: "",
        isShared: 1, //0 非共享资源  1 共享资源
        linkName: "",
        linkUrl: "",
      },
      rules: {
        categoryId: [
          { required: true, message: "请选择资源分类", trigger: "change" },
        ],
        linkName: [
          { required: true, message: "请输入链接名称", trigger: "blur" },
        ],
        linkUrl: [
          { required: true, validator: checkUrl, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.findResCategoryByCourseId(
      this.courseId ? this.courseId : this.$route.query.id
    );
  },
  watch: {
    tableRowData: {
      handler: function(val) {
        if ( Object.keys(val).length != 0 ) {
          this.ruleForm = {
            categoryResourceId: val.categoryResourceId,
            categoryId: val.categoryId,
            isShared: 1, //0 非共享资源  1 共享资源
            linkName: val.name,
            linkUrl: val.downloadUrl,
          }
        } else {
          this.ruleForm = {
            categoryId: "",
            isShared: 1, //0 非共享资源  1 共享资源
            linkName: "",
            linkUrl: "",
          }
        }
      },
      immediate: true,
      deep: true,
    }
  },
  mounted() {},
  methods: {
    // 查询资源分类
    findResCategoryByCourseId(id) {
      api
        .FindResCategoryByCourseId(id)
        .then((res) => {
          if (res.code == "0") {
            this.resourceDatas = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submitForm() {
      console.log(1111);
    }
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/components/addLink.vue